import axios from 'axios';
import { getApiBaseUrl } from '../auth/apiBaseUrl';

const API_URL = getApiBaseUrl();

export const signUp = async (userData: {
  emailAddress: string;
  password: string;
  inviteToken?: string;
}) => {
  try {
    const { emailAddress, password, inviteToken } = userData;

    const payload: {
      emailAddress: string;
      password: string;
      inviteToken?: string;
    } = {
      emailAddress,
      password,
    };

    if (inviteToken) {
      payload.inviteToken = inviteToken;
    }

    const response = await axios.post(`${API_URL}/User/sign-up`, payload);

    return response;
  } catch (error: unknown) {
    const err = error as { response?: { data?: { message?: string } }; message?: string };
    const errorMessage = err.response?.data?.message || err.message || 'Sign-up failed';
    console.error('Error during sign-up:', errorMessage);
    throw new Error(errorMessage);
  }
};
